// extracted by mini-css-extract-plugin
export default {"clickable":"switch_clickable__bTu2G"};